import { useCallback, useEffect, useMemo } from 'react';
import { useFluxStore } from '@evertrue/et-flux';
import EventsHeader from 'apps/events/components/events-header';
import EventsTable from 'apps/events/components/events-table';
import EventsSource from 'apps/events/sources/events-source';
import EventsStore from 'apps/events/stores/events-store';
import FacebookPagesStore from 'apps/facebook/stores/facebook-pages-store';
import FacebookSource from 'apps/facebook/sources/facebook-source';
import Searchbox from 'components/forms/search-box';
import Layout from 'components/layout';
import _ from 'underscore';

const eventsStoreMap = () => ({
  events: EventsStore.getEvents(),
  quickSearch: EventsStore.getQuickSearch(),
  loading: EventsStore.getIsLoading(),
});

const facebookPagesStoreMap = () => ({
  pages: FacebookPagesStore.getPages(),
});

const EventsController = () => {
  const { events, quickSearch, loading } = useFluxStore(EventsStore, () => eventsStoreMap);

  const { pages } = useFluxStore(FacebookPagesStore, () => facebookPagesStoreMap);

  useEffect(() => {
    FacebookSource.fetchPages();
  }, []);

  useEffect(() => {
    EventsSource.setPage(1);
  }, []);

  const debounceSearch = useMemo(() => _.debounce(EventsSource.setQuickSearch, 300), []);

  const renderFacebookPageData = useCallback(() => {
    return events.map((event) => {
      const page = _.findWhere(pages, { remote_id: event.page_remote_id });
      const pageName = page?.page_name;
      return pageName ? { ...event, page_name: pageName } : event;
    });
  }, [events, pages]);

  const renderHeader = () => (
    <div className="events-controller--filters-wrapper">
      <EventsHeader />
    </div>
  );

  const renderControls = () => (
    <div className="events-controller--controls-wrapper">
      <Searchbox
        className="events-controller--searchbox"
        name=""
        placeholder="Search by name or location..."
        defaultValue={quickSearch}
        onKeyUp={(query) => debounceSearch(query)}
      />
    </div>
  );

  const header = (
    <div className="events-controller--header">
      {renderHeader()}
      {renderControls()}
    </div>
  );

  return (
    <div className="events-controller">
      <Layout header={header}>
        <div className="events-controller--events-table-wrapper">
          <EventsTable data={renderFacebookPageData()} loading={loading} />
        </div>
      </Layout>
    </div>
  );
};

export default EventsController;
